import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Users } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const options = [{
  id: 'science',
  label: 'The scientific sessions',
  percent: 38
}, {
  id: 'booth',
  label: 'Booth conversations',
  percent: 27
}, {
  id: 'people',
  label: 'Meeting the people',
  percent: 22
}, {
  id: 'energy',
  label: 'The overall energy',
  percent: 13
}];
export const PostScreenPollHighlight = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState<string | null>(null);
  const [revealed, setRevealed] = useState(false);
  const handleSelect = (id: string) => {
    if (revealed) return;
    setSelected(id);
    setTimeout(() => setRevealed(true), 600);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-171">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-172">
        <video src="https://cdn.magicpatterns.com/uploads/fQFTKhbTs1W58wgx5hcKuv/stand.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-50" data-id="element-173" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-slate-950/60 to-slate-950/95" data-id="element-174" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-175">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-4" data-id="element-176">
          05 — Your Highlight
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-8" data-id="element-177">
          What was <span className="text-green-500" data-id="element-178">YOUR</span> highlight of
          ERA?
        </motion.h2>

        <div className="space-y-3 flex-1" data-id="element-179">
          {options.map((opt, i) => {
          const isSelected = selected === opt.id;
          return <motion.button key={opt.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + i * 0.1
          }} onClick={() => handleSelect(opt.id)} disabled={revealed} className={`relative w-full text-left p-4 rounded-2xl border transition-all duration-500 overflow-hidden ${!revealed ? isSelected ? 'bg-green-600/20 border-green-500 text-white' : 'bg-slate-900/80 border-slate-800 text-slate-300 hover:border-slate-600' : isSelected ? 'bg-slate-800 border-green-500 text-white' : 'bg-slate-900/50 border-slate-800 text-slate-400'}`} data-id="element-180">
                {revealed && <motion.div initial={{
              width: 0
            }} animate={{
              width: `${opt.percent}%`
            }} transition={{
              duration: 1,
              ease: 'easeOut'
            }} className={`absolute inset-y-0 left-0 ${isSelected ? 'bg-green-600/30' : 'bg-slate-700/30'}`} data-id="element-181" />}
                <div className="relative z-10 flex justify-between items-center" data-id="element-182">
                  <span className="text-sm font-medium" data-id="element-183">{opt.label}</span>
                  {revealed && <motion.span initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} transition={{
                delay: 1
              }} className={`text-sm font-bold ${isSelected ? 'text-green-400' : 'text-slate-500'}`} data-id="element-184">
                      {opt.percent}%
                    </motion.span>}
                </div>
              </motion.button>;
        })}
        </div>

        <AnimatePresence data-id="element-185">
          {revealed && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6" data-id="element-186">
              <div className="flex items-center justify-center space-x-2 text-xs text-slate-400 mb-4" data-id="element-187">
                <Users className="w-3 h-3" data-id="element-188" />
                <span data-id="element-189">Joined by 127 colleagues</span>
              </div>
              <button onClick={onNext} className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-190">
                <span data-id="element-191">Continue</span>
                <ArrowRight className="w-5 h-5" data-id="element-192" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
};